import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { ToastProvider } from './context/ToastContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import Home from './pages/Home';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import About from './pages/About';
import {
  CommercialTransactionInformationPage,
  ReturnRefundPolicyPage,
  PaymentMethodsPage,
  PrivacyPolicyPage,
  TermsConditionsPage,
  ContactUsPage,
} from './pages/InfoPages';
import './index.css';

function App() {
  return (
    <Router>
      <CartProvider>
        <ToastProvider>
          <div className="app">
            <Navbar />
            <CartDrawer />
            <div className="main-content">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/about" element={<About />} />
                <Route path="/payment-methods" element={<PaymentMethodsPage />} />
                <Route path="/return-refund-policy" element={<ReturnRefundPolicyPage />} />
                <Route path="/commercial-transaction-information" element={<CommercialTransactionInformationPage />} />
                <Route path="/terms-conditions" element={<TermsConditionsPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/contact-us" element={<ContactUsPage />} />
              </Routes>
            </div>
            <Footer />
          </div>
        </ToastProvider>
      </CartProvider>
    </Router>
  );
}

export default App;
